import { withIcon } from "../Icon"

export const IconClock = withIcon(
  '<path fill="none" stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M12 20a7.974 7.974 0 0 0 5.657-2.343A7.974 7.974 0 0 0 20 12a7.976 7.976 0 0 0-2.343-5.657A7.975 7.975 0 0 0 12 4a7.975 7.975 0 0 0-5.657 2.343A7.975 7.975 0 0 0 4 12a7.974 7.974 0 0 0 2.343 5.657A7.974 7.974 0 0 0 12 20Z"/><path fill="currentColor" d="M11.7 9H10v4.353L12.798 16 14 14.863l-2.3-2.176V9Z"/>',
)
